import React from 'react';

import AfterDoc from '@/components/ui/AfterDoc';
import { PRODUCT } from '@/consts';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const ThankYouContactWaitingForDecision = () => {
  const { i18n } = useLingui();

  return (
    <AfterDoc
      consultant={CONSULTANTS.MARTA_ASSISTANT}
      thankYouMessage={i18n.t('Czekamy na decyzję!')}
      withButton
      productId={PRODUCT.HOUSE_HOLD}
    >
      <div>
        <p className="body pb-2">
          {i18n.t(
            'Do momentu uzyskania pozytywnej decyzji ubezpieczyciela w Twojej sprawie, konieczne jest wstrzymanie dalszych działań z naszej strony.'
          )}
        </p>
        <p>
          {i18n.t(
            'Wróć do nas w przypadku otrzymania pozytywnej decyzji. Wówczas będziemy mogli podjąć odpowiednie kroki w celu dalszej realizacji sprawy.'
          )}
        </p>
      </div>
      <p className="body font-semibold">
        {i18n.t('W przypadku pytań zapraszamy do kontaktu.')}
      </p>
    </AfterDoc>
  );
};

export default ThankYouContactWaitingForDecision;
